import { _ as _sfc_main } from "./chunks/p-alert.js";
import PCloseBtn from "./p-close-btn.js";
import { defineComponent, useCssVars, resolveComponent, createBlock, createCommentVNode, openBlock, Teleport, createVNode, Transition, withCtx, withDirectives, createElementVNode, normalizeStyle, normalizeClass, vShow, renderSlot, createElementBlock, toDisplayString } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const __default__ = defineComponent({
  name: "PDrawer",
  components: {
    PAlert: _sfc_main,
    PCloseBtn
  },
  props: {
    appendTo: {
      type: String,
      default: "body"
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "right"
    },
    zIndex: {
      type: Number,
      default: 900
    },
    drawerStyle: {
      type: Object,
      default: () => ({})
    },
    drawerClass: {
      type: String,
      default: "drawer"
    },
    inClass: {
      type: String,
      default: ""
    },
    outClass: {
      type: String,
      default: ""
    },
    live: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    closeLabel: {
      type: String,
      default: "Close"
    },
    showBackdrop: {
      type: Boolean,
      default: false
    },
    enableClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "460px",
      validator: (value) => {
        return !!value.match(/^[0-9]+px$/);
      }
    }
  },
  emits: ["update:modelValue", "before-open", "opening", "opened", "before-close", "closing", "closed"],
  data() {
    return {
      id: null,
      show: false,
      mount: false
    };
  },
  computed: {
    transitionInClass() {
      return this.inClass || this.position === "right" ? "slideInRight" : "slideInLeft";
    },
    transitionOutClass() {
      return this.outClass || this.position === "right" ? "slideOutRight" : "slideOutLeft";
    }
  },
  created() {
    if (this.live) {
      this.mount = true;
    }
  },
  mounted() {
    this.id = "drawer-" + this.$.uid;
    this.$watch(
      "modelValue",
      (newVal) => {
        if (newVal) {
          this.mount = true;
          this.$nextTick(() => {
            this.show = true;
          });
        } else {
          this.show = false;
        }
      },
      { immediate: true }
    );
  },
  methods: {
    close() {
      if (this.enableClose === true) {
        this.$emit("update:modelValue", false);
      }
    },
    beforeOpen() {
      this.$emit("before-open");
    },
    opening() {
      this.$emit("opening");
    },
    opened() {
      this.$emit("opened");
    },
    beforeClose() {
      this.$emit("before-close");
    },
    closing() {
      this.$emit("closing");
    },
    closed() {
      if (!this.live) {
        this.mount = false;
      }
      this.$nextTick(() => {
        this.$emit("closed");
      });
    }
  }
});
const __injectCSSVars__ = () => {
  useCssVars((_ctx) => ({
    "508822d0": _ctx.width
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
const _hoisted_1 = ["data-drawer-id", "aria-label", "aria-describedby", "aria-labelledby"];
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  key: 0,
  class: "px-6 pt-6"
};
const _hoisted_4 = { class: "whitespace-pre-line" };
const _hoisted_5 = { class: "footer p-6" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PCloseBtn = resolveComponent("PCloseBtn");
  const _component_PAlert = resolveComponent("PAlert");
  return _ctx.mount ? (openBlock(), createBlock(Teleport, {
    key: 0,
    to: _ctx.appendTo
  }, [
    createVNode(Transition, {
      name: "pd-backdrop-transition",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut"
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          class: normalizeClass(["fixed bottom-0 left-0 right-0 top-0 bg-black/20", { "cursor-pointer": _ctx.enableClose }]),
          style: normalizeStyle({ "z-index": _ctx.zIndex - 1 }),
          tabindex: "-1",
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.close && _ctx.close(...args))
        }, null, 6), [
          [vShow, _ctx.show && _ctx.showBackdrop]
        ])
      ]),
      _: 1
    }),
    createVNode(Transition, {
      name: "drawer-transition",
      "enter-active-class": _ctx.transitionInClass,
      "leave-active-class": _ctx.transitionOutClass,
      onBeforeEnter: _ctx.beforeOpen,
      onEnter: _ctx.opening,
      onAfterEnter: _ctx.opened,
      onBeforeLeave: _ctx.beforeClose,
      onLeave: _ctx.closing,
      onAfterLeave: _ctx.closed
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          "data-drawer-id": _ctx.id,
          tabindex: "-1",
          class: normalizeClass([_ctx.drawerClass, _ctx.position === "right" ? "drawer-right" : "drawer-left"]),
          style: normalizeStyle({ "z-index": _ctx.zIndex, ..._ctx.drawerStyle }),
          role: "dialog",
          "aria-label": _ctx.title,
          "aria-modal": "false",
          "aria-describedby": `${_ctx.id}-content`,
          "aria-labelledby": `${_ctx.id}-title`
        }, [
          renderSlot(_ctx.$slots, "title-wrapper", {}, () => [
            createElementVNode("div", {
              class: normalizeClass([
                "flex items-center border-b border-p-gray-30 px-6 pb-4 pt-4",
                { "flex-row-reverse": _ctx.position === "right" }
              ])
            }, [
              _ctx.enableClose ? (openBlock(), createBlock(_component_PCloseBtn, {
                key: 0,
                "aria-label": _ctx.closeLabel,
                class: "flex-0",
                disabled: _ctx.disabled,
                onClick: _ctx.close
              }, null, 8, ["aria-label", "disabled", "onClick"])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "title", {}, () => [
                _ctx.title ? (openBlock(), createElementBlock("h3", {
                  key: 0,
                  id: `${_ctx.id}-title`,
                  class: normalizeClass(["flex-1 text-xl font-medium leading-8", { "text-right": _ctx.position === "left" }])
                }, toDisplayString(_ctx.title), 11, _hoisted_2)) : createCommentVNode("", true)
              ], true)
            ], 2)
          ], true),
          _ctx.errorMsg ? (openBlock(), createElementBlock("div", _hoisted_3, [
            createVNode(_component_PAlert, { type: "error" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4, toDisplayString(_ctx.errorMsg), 1)
              ]),
              _: 1
            })
          ])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "content-wrapper", {}, () => [
            createElementVNode("div", {
              class: normalizeClass([
                "relative grow overflow-y-auto overflow-x-hidden px-6 pt-6",
                { "pointer-events-none opacity-50": _ctx.disabled }
              ])
            }, [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 2)
          ], true),
          renderSlot(_ctx.$slots, "footer-wrapper", {}, () => [
            createElementVNode("div", _hoisted_5, [
              renderSlot(_ctx.$slots, "footer", {}, void 0, true)
            ])
          ], true)
        ], 14, _hoisted_1), [
          [vShow, _ctx.show]
        ])
      ]),
      _: 3
    }, 8, ["enter-active-class", "leave-active-class", "onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])
  ], 8, ["to"])) : createCommentVNode("", true);
}
const pDrawer = /* @__PURE__ */ _export_sfc(__default__, [["render", _sfc_render], ["__scopeId", "data-v-95d3e794"]]);
export {
  pDrawer as default
};
